import React, { useEffect, useState } from "react";
import DatePopUp from "./date_popup.js";
import "../styles/history_popup.css";
import { secretKey } from "../.././data";
import Loading from "../helpers/loading_component.js";
import MaterialBox from "./materialBox.js";

const Materials = (props) => {
  const [hearings, setHearings] = useState([]);
  const [hearingsOri, setHearingsOri] = useState([]);
  const [showDate, setShowDate] = useState(false);
  const [date, setDate] = useState("");
  const [search, setSearch] = useState("");
  const [searchWord, setSearchWord] = useState("");
  const [wordFlag, setWordFlag] = useState(false);
  const [searchSec, setSearchSec] = useState("");
  const [searchThird, setSearchThird] = useState("");
  const [mode, setMode] = useState("dep");
  const [departments, setDepartments] = useState([]);
  const [departmentsSec, setDepartmentsSec] = useState([]);
  const [departmentDetail, setDepartmentDetail] = useState("");
  const [departmentDetailSec, setDepartmentDetailSec] = useState("");
  const [words, setWords] = useState([]);
  const [loading, setLoading] = useState(true);

  const closeDatePopUp = (e) => {
    setShowDate(!showDate);
    setDate("");
    getData();
  };

  const showDatePopUp = (e) => {
    e.preventDefault();
    var value = e.currentTarget.attributes.value.value;
    setDate(hearings.filter((el) => +el.id === +value)[0]);
    showDateP();
  };

  const showDateP = () => {
    setShowDate(true);
  };

  const fetchHearings = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getMaterials", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHearings(data);
        setHearingsOri(data);
        fetchDepartments();
      })
      .catch((error) => {});
  };

  const fetchDepartments = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getMaterialsDepartments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setDepartments(data);
        fetchDepartmentsSec();
      })
      .catch((error) => {});
  };

  const fetchDepartmentsSec = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getMaterialsDepartmentsSec", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setDepartmentsSec(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchHearings();
  };

  useEffect(() => {
    getData();
  }, []);

  const setDepartmentMenu = (e) => {
    setDepartmentDetail(e.target.value);
    setMode("depSec");
  };

  const setDepartmentSecMenu = (e) => {
    setDepartmentDetailSec(e.target.value);
    setMode("depDetail");
  };

  const searchArtSec = (e) => {
    setHearings(
      hearings.filter(
        (h) =>
          h.name.toLowerCase().includes(searchSec.toLowerCase()) ||
          h.content.toLowerCase().includes(searchSec.toLowerCase())
      ).length > 0
        ? hearings.filter(
            (h) =>
              h.name.toLowerCase().includes(searchSec.toLowerCase()) ||
              h.content.toLowerCase().includes(searchSec.toLowerCase())
          )
        : []
    );
  };

  const searchArtSecClear = (e) => {
    if (search) {
      setHearings(
        hearings.filter(
          (h) =>
            h.name.toLowerCase().includes(search.toLowerCase()) ||
            h.content.toLowerCase().includes(search.toLowerCase())
        ).length > 0
          ? hearings.filter(
              (h) =>
                h.name.toLowerCase().includes(search.toLowerCase()) ||
                h.content.toLowerCase().includes(search.toLowerCase())
            )
          : []
      );
    } else {
      setHearings(hearingsOri);
    }

    setSearchSec("");
  };

  const searchArt = (e) => {
    setHearings(
      hearings.filter(
        (h) =>
          h.name.toLowerCase().includes(search.toLowerCase()) ||
          h.content.toLowerCase().includes(search.toLowerCase())
      ).length > 0
        ? hearings.filter(
            (h) =>
              h.name.toLowerCase().includes(search.toLowerCase()) ||
              h.content.toLowerCase().includes(search.toLowerCase())
          )
        : []
    );
  };

  function locations(substring, string, title) {
    var a = [],
      i = -1;
    while ((i = string.indexOf(substring, i + 1)) >= 0) a.push(i);
    return a;
  }

  const searchWordF = (e) => {
    setWordFlag(true);
    var arr = [];
    hearingsOri.map((el) => {
      try {
        var str = el.content.replace(/<[^>]*>?/gm, "");
        var indices = locations(searchWord, str);
        var indices2 = locations(searchWord, el.name);

        if (indices.length > 0) {
          indices.map((eq) => {
            var test = str.substr(eq - 10 < 0 ? 0 : eq - 10, 200) + " - TREŚĆ";
            if (test.length > 0) {
              var obj = {
                content: test,
                idMaterial: el.id,
                title: el.name,
                category: departments.filter(
                  (ex) => +el.department === +ex.id
                )[0].name,
              };
              arr.push(obj);
            }
          });
        }

        if (indices2.length > 0) {
          indices2.map((eq) => {
            var test =
              el.name.substr(eq - 10 < 0 ? 0 : eq - 10, 200) + " - TYTUŁ";
            if (test.length > 0) {
              var obj = {
                content: test,
                idMaterial: el.id,
                title: el.name,
                category: departments.filter(
                  (ex) => +el.department === +ex.id
                )[0].name,
              };
              arr.push(obj);
            }
          });
        }
      } catch (err) {}
    });

    setWords(arr);
  };

  const clearSearch = (e) => {
    setMode("dep");
    setSearch("");
    setSearchSec("");
    setSearchThird("");
    setHearings(hearingsOri);
  };

  const clearSearchWord = (e) => {
    setMode("dep");
    setSearch("");
    setSearchSec("");
    setSearchWord("");
    setSearchThird("");
    setHearings(hearingsOri);
    setWordFlag(false);
  };

  const searchArtThird = (e) => {
    setHearings(
      hearings.filter(
        (h) =>
          h.name.toLowerCase().includes(searchThird.toLowerCase()) ||
          h.content.toLowerCase().includes(searchThird.toLowerCase())
      ).length > 0
        ? hearings.filter(
            (h) =>
              h.name.toLowerCase().includes(searchThird.toLowerCase()) ||
              h.content.toLowerCase().includes(searchThird.toLowerCase())
          )
        : []
    );
  };

  const searchArtThirdClear = (e) => {
    if (searchSec && search) {
      setHearings(
        hearings.filter(
          (h) =>
            (h.name.toLowerCase().includes(searchSec.toLowerCase()) &&
              h.name.toLowerCase().includes(search.toLowerCase())) ||
            (h.content.toLowerCase().includes(searchSec.toLowerCase()) &&
              h.content.toLowerCase().includes(search.toLowerCase()))
        ).length > 0
          ? hearings.filter(
              (h) =>
                (h.name.toLowerCase().includes(searchSec.toLowerCase()) &&
                  h.name.toLowerCase().includes(search.toLowerCase())) ||
                (h.content.toLowerCase().includes(searchSec.toLowerCase()) &&
                  h.content.toLowerCase().includes(search.toLowerCase()))
            )
          : []
      );
    } else if (searchSec && !search) {
      setHearings(
        hearings.filter(
          (h) =>
            h.name.toLowerCase().includes(searchSec.toLowerCase()) ||
            h.content.toLowerCase().includes(searchSec.toLowerCase())
        ).length > 0
          ? hearings.filter(
              (h) =>
                h.name.toLowerCase().includes(searchSec.toLowerCase()) ||
                h.content.toLowerCase().includes(searchSec.toLowerCase())
            )
          : []
      );
    } else if (search && !searchSec) {
      setHearings(
        hearings.filter(
          (h) =>
            h.name.toLowerCase().includes(search.toLowerCase()) ||
            h.content.toLowerCase().includes(search.toLowerCase())
        ).length > 0
          ? hearings.filter(
              (h) =>
                h.name.toLowerCase().includes(search.toLowerCase()) ||
                h.content.toLowerCase().includes(search.toLowerCase())
            )
          : []
      );
    } else {
      setHearings(hearingsOri);
    }

    setSearchThird("");
  };

  const keyDownCatA = (e) => {
    if (e.key === "Enter") {
      searchArt();
    }
  };

  const keyDownWord = (e) => {
    if (e.key === "Enter") {
      searchWordF();
    }
  };

  const departmentsMenu = (
    <>
      <div>
        <div style={{ display: "flex", gap: "30px" }}>
          <div
            style={{
              marginTop: "3vh",
              marginBottom: "5vh",
              width: "40%",

              alignItems: "center",
            }}
          >
            <p style={{ margin: "0", marginBottom: "10px", fontSize: ".8vw" }}>
              wyszukaj w kategoriach
            </p>
            <div style={{ display: "flex", gap: "10px" }}>
              <input
                type="text"
                id="signature"
                name="signature"
                style={{ height: "3vh", margin: "0", borderColor: "lightgray" }}
                value={search}
                onKeyDown={keyDownCatA}
                onChange={(e) => {
                  setSearch(e.target.value.toLowerCase());
                }}
              />
              <button
                className="closeClientButton"
                style={{
                  height: "3vh",
                  borderRadius: "30px",
                  backgroundColor: "lightgray",
                  color: "black",
                }}
                onClick={searchArt}
              >
                WYSZUKAJ
              </button>
              <button
                className="closeClientButton"
                style={{
                  height: "3vh",
                  borderRadius: "30px",
                  backgroundColor: "lightgray",
                  color: "black",
                }}
                onClick={clearSearch}
              >
                WYCZYŚĆ
              </button>
            </div>
          </div>
          <div
            style={{
              marginTop: "3vh",
              marginBottom: "5vh",
              width: "40%",

              alignItems: "center",
            }}
          >
            <p style={{ margin: "0", marginBottom: "10px", fontSize: ".8vw" }}>
              wyszukaj w treści materiału
            </p>
            <div style={{ display: "flex", gap: "10px" }}>
              <input
                type="text"
                id="signature"
                name="signature"
                style={{ height: "3vh", margin: "0", borderColor: "green" }}
                onKeyDown={keyDownWord}
                value={searchWord}
                onChange={(e) => {
                  setSearchWord(e.target.value.toLowerCase());
                }}
              />
              <button
                className="closeClientButton"
                style={{
                  height: "3vh",
                  borderRadius: "30px",
                  backgroundColor: "green",
                  color: "white",
                }}
                onClick={searchWordF}
              >
                WYSZUKAJ
              </button>
              <button
                className="closeClientButton"
                style={{
                  height: "3vh",
                  borderRadius: "30px",
                  backgroundColor: "green",
                  color: "white",
                }}
                onClick={clearSearchWord}
              >
                WYCZYŚĆ
              </button>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
        {departments
          ? departments
              .filter(
                (x) =>
                  props.user.adminMaterials === "1" ||
                  x.allowed === "all" ||
                  x.allowed.includes(props.user.id)
              )
              .map((el) => (
                <button
                  className="materialKafel"
                  style={{
                    width: "15vw",
                    height: "15vw",
                    backgroundColor: "lightgray",
                    display: "flex",
                    gap: "10px",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "30px",
                    textTransform: "uppercase",
                    cursor: "pointer",
                  }}
                  value={el.id}
                  onClick={
                    hearings.filter((h) => +h.department === +el.id).length ===
                    0
                      ? () => {
                          return;
                        }
                      : setDepartmentMenu
                  }
                >
                  <span style={{ width: "100%", margin: "0px" }}>
                    {el.name}
                  </span>
                  <span
                    style={{
                      width: "100%",
                      margin: "0px",
                      fontSize: "1vw",
                      color: "gray",
                    }}
                  >
                    {hearings.filter((h) => +h.department === +el.id).length}{" "}
                    szt.
                  </span>
                </button>
              ))
          : ""}
      </div>
    </>
  );

  const backDepMenu = () => {
    setMode("depSec");
  };

  const backDepSecMenu = () => {
    setMode("dep");
  };

  const keyDownCatB = (e) => {
    if (e.key === "Enter") {
      searchArtSec();
    }
  };

  const departmentsSecMenu = (
    <>
      <div
        style={{ width: "100%", textAlign: "left", paddingBottom: "5vh" }}
        className="closeBox"
      >
        <button className="closeClientButton" onClick={backDepSecMenu}>
          WSTECZ
        </button>
      </div>
      <div>
        <div style={{ display: "flex", gap: "30px" }}>
          <div
            style={{
              marginTop: "3vh",
              marginBottom: "5vh",
              width: "40%",

              alignItems: "center",
            }}
          >
            <p style={{ margin: "0", marginBottom: "10px", fontSize: ".8vw" }}>
              wyszukaj w kategoriach
            </p>
            <div style={{ display: "flex", gap: "10px" }}>
              <input
                type="text"
                id="signature"
                name="signature"
                style={{ height: "3vh", margin: "0", borderColor: "lightgray" }}
                value={searchSec}
                onKeyDown={keyDownCatB}
                onChange={(e) => {
                  setSearchSec(e.target.value.toLowerCase());
                }}
              />
              <button
                className="closeClientButton"
                style={{
                  height: "3vh",
                  borderRadius: "30px",
                  backgroundColor: "lightgray",
                  color: "black",
                }}
                onClick={searchArtSec}
              >
                WYSZUKAJ
              </button>
              <button
                className="closeClientButton"
                style={{
                  height: "3vh",
                  borderRadius: "30px",
                  backgroundColor: "lightgray",
                  color: "black",
                }}
                onClick={searchArtSecClear}
              >
                WYCZYŚĆ
              </button>
            </div>
          </div>
          <div
            style={{
              marginTop: "3vh",
              marginBottom: "5vh",
              width: "40%",

              alignItems: "center",
            }}
          >
            <p style={{ margin: "0", marginBottom: "10px", fontSize: ".8vw" }}>
              wyszukaj w treści materiału
            </p>
            <div style={{ display: "flex", gap: "10px" }}>
              <input
                type="text"
                id="signature"
                name="signature"
                style={{ height: "3vh", margin: "0", borderColor: "green" }}
                onKeyDown={keyDownWord}
                value={searchWord}
                onChange={(e) => {
                  setSearchWord(e.target.value.toLowerCase());
                }}
              />
              <button
                className="closeClientButton"
                style={{
                  height: "3vh",
                  borderRadius: "30px",
                  backgroundColor: "green",
                  color: "white",
                }}
                onClick={searchWordF}
              >
                WYSZUKAJ
              </button>
              <button
                className="closeClientButton"
                style={{
                  height: "3vh",
                  borderRadius: "30px",
                  backgroundColor: "green",
                  color: "white",
                }}
                onClick={clearSearchWord}
              >
                WYCZYŚĆ
              </button>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
        {departmentsSec
          .filter(
            (x) =>
              props.user.adminMaterials === "1" ||
              x.allowed === "all" ||
              x.allowed.includes(props.user.id)
          )
          .map((el) => (
            <button
              className="materialKafel"
              style={{
                width: "15vw",
                height: "15vw",
                backgroundColor: "lightgray",
                display: "flex",
                gap: "10px",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "30px",
                textTransform: "uppercase",
                cursor: "pointer",
              }}
              value={el.id}
              onClick={
                hearings.filter(
                  (h) =>
                    +h.departmentSec === +el.id &&
                    +h.department === +departmentDetail
                ).length === 0
                  ? () => {
                      return;
                    }
                  : setDepartmentSecMenu
              }
            >
              <span style={{ width: "100%", margin: "0px" }}>{el.name}</span>
              <span
                style={{
                  width: "100%",
                  margin: "0px",
                  fontSize: "1vw",
                  color: "gray",
                }}
              >
                {
                  hearings.filter(
                    (h) =>
                      +h.departmentSec === +el.id &&
                      +h.department === +departmentDetail
                  ).length
                }{" "}
                szt.
              </span>
            </button>
          ))}
      </div>
    </>
  );

  const keyDownCatC = (e) => {
    if (e.key === "Enter") {
      searchArtThird();
    }
  };

  const departmentDetailMenu = (
    <>
      <div
        style={{ width: "100%", textAlign: "left", paddingBottom: "5vh" }}
        className="closeBox"
      >
        <button className="closeClientButton" onClick={backDepMenu}>
          WSTECZ
        </button>
      </div>
      <div>
        <div style={{ display: "flex", gap: "30px" }}>
          <div
            style={{
              marginTop: "3vh",
              marginBottom: "5vh",
              width: "40%",

              alignItems: "center",
            }}
          >
            <p style={{ margin: "0", marginBottom: "10px", fontSize: ".8vw" }}>
              wyszukaj w kategoriach
            </p>
            <div style={{ display: "flex", gap: "10px" }}>
              <input
                type="text"
                id="signature"
                name="signature"
                style={{ height: "3vh", margin: "0", borderColor: "lightgray" }}
                value={searchThird}
                onKeyDown={keyDownCatC}
                onChange={(e) => {
                  setSearchThird(e.target.value.toLowerCase());
                }}
              />
              <button
                className="closeClientButton"
                style={{
                  height: "3vh",
                  borderRadius: "30px",
                  backgroundColor: "lightgray",
                  color: "black",
                }}
                onClick={searchArtThird}
              >
                WYSZUKAJ
              </button>
              <button
                className="closeClientButton"
                style={{
                  height: "3vh",
                  borderRadius: "30px",
                  backgroundColor: "lightgray",
                  color: "black",
                }}
                onClick={searchArtThirdClear}
              >
                WYCZYŚĆ
              </button>
            </div>
          </div>
          <div
            style={{
              marginTop: "3vh",
              marginBottom: "5vh",
              width: "40%",

              alignItems: "center",
            }}
          >
            <p style={{ margin: "0", marginBottom: "10px", fontSize: ".8vw" }}>
              wyszukaj w treści materiału
            </p>
            <div style={{ display: "flex", gap: "10px" }}>
              <input
                type="text"
                id="signature"
                name="signature"
                style={{ height: "3vh", margin: "0", borderColor: "green" }}
                value={searchWord}
                onChange={(e) => {
                  setSearchWord(e.target.value.toLowerCase());
                }}
              />
              <button
                className="closeClientButton"
                style={{
                  height: "3vh",
                  borderRadius: "30px",
                  backgroundColor: "green",
                  color: "white",
                }}
                onClick={searchWordF}
              >
                WYSZUKAJ
              </button>
              <button
                className="closeClientButton"
                style={{
                  height: "3vh",
                  borderRadius: "30px",
                  backgroundColor: "green",
                  color: "white",
                }}
                onClick={clearSearchWord}
              >
                WYCZYŚĆ
              </button>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
        {hearings
          ? hearings
              .filter(
                (x) =>
                  props.user.adminMaterials === "1" ||
                  x.allowed === "all" ||
                  x.allowed.includes(props.user.id)
              )
              .filter(
                (h) =>
                  +h.departmentSec === +departmentDetailSec &&
                  +h.department === +departmentDetail
              )
              .map((el) => (
                <div
                  className="materialKafel"
                  style={{
                    width: "33%",
                    height: "10vw",
                    backgroundColor: "lightgray",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "30px",
                    textTransform: "uppercase",
                    cursor: "pointer",
                    textAlign: "center",
                  }}
                  value={el.id}
                  onClick={showDatePopUp}
                >
                  {el.name}
                </div>
              ))
          : ""}
      </div>
    </>
  );

  const searchMenu = (
    <>
      <div
        style={{ width: "100%", textAlign: "left", paddingBottom: "5vh" }}
        className="closeBox"
      >
        <button className="closeClientButton" onClick={clearSearch}>
          WYCZYŚĆ
        </button>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
        {hearings.filter(
          (h) =>
            h.name.toLowerCase().includes(search.toLowerCase()) ||
            h.content.toLowerCase().includes(search.toLowerCase())
        ).length > 0
          ? hearings
              .filter(
                (h) =>
                  h.name.toLowerCase().includes(search.toLowerCase()) ||
                  h.content.toLowerCase().includes(search.toLowerCase())
              )
              .map((el) => (
                <div
                  className="materialKafel"
                  style={{
                    width: "33%",
                    height: "10vw",
                    backgroundColor: "lightgray",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "30px",
                    textTransform: "uppercase",
                    cursor: "pointer",
                  }}
                  value={el.id}
                  onClick={showDatePopUp}
                >
                  {el.name}
                </div>
              ))
          : "brak wyników"}
      </div>
    </>
  );

  const destopData = (
    <>
      <>
        <div className="closeBox">
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>

        {mode === "dep" ? <> {departmentsMenu} </> : ""}
        {mode === "depSec" ? <> {departmentsSecMenu} </> : ""}
        {mode === "depDetail" ? <>{departmentDetailMenu}</> : ""}
        {mode === "search" ? <>{searchMenu}</> : ""}
      </>
    </>
  );

  const searchWordC = (
    <>
      <div
        style={{ width: "100%", textAlign: "left", paddingBottom: "5vh" }}
        className="closeBox"
      >
        <button className="closeClientButton" onClick={clearSearchWord}>
          WSTECZ
        </button>
      </div>
      <p style={{ fontSize: ".8vw", textAlign: "right" }}>
        Liczba wyników: {words.length}
      </p>
      <table className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Treść</th>
          <th>Tytuł</th>
          <th>Kategoria</th>
          <th>Akcja</th>
        </tr>
        {words.map((el, index) => (
          <>
            <tr id={""} key={index}>
              <td>{index + 1}</td>
              <td
                style={{
                  textAlign: "left",
                  paddingLeft: "5px",
                  fontWeight: "600",
                  maxWidth: "15%",
                  wordBreak: "break-word",
                }}
              >
                ...{el.content}
              </td>
              <td>{el.title}</td>
              <td>{el.category}</td>
              <td style={{ padding: "10px" }}>
                <div
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "5px",
                    textTransform: "uppercase",
                    cursor: "pointer",
                    padding: "10px",
                  }}
                  value={el.idMaterial}
                  onClick={showDatePopUp}
                >
                  ZOBACZ
                </div>
              </td>
            </tr>
          </>
        ))}
      </table>
    </>
  );

  return (
    <>
      {showDate ? (
        <>
          <MaterialBox closePopUp={closeDatePopUp} material={date} />
        </>
      ) : (
        ""
      )}
      {showDate ? (
        ""
      ) : (
        <div className="mainContainerDatePopUp">
          {loading ? (
            <Loading id="popUpLoading" />
          ) : (
            <>{wordFlag ? searchWordC : destopData}</>
          )}
        </div>
      )}
    </>
  );
};

export default Materials;
